import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import TranslationsManager from './TranslationsManager';

const TranslationsManagerContext = createContext();

const TranslationsProvider = ({ children, options }) => {
  const translationsManager = useMemo(
    () => TranslationsManager(options),
    [options]
  );
  useEffect(() => {
    return () => translationsManager.clear();
  }, [translationsManager]);
  return (
    <I18nextProvider i18n={translationsManager.getI18next()}>
      <TranslationsManagerContext.Provider value={translationsManager}>
        {children}
      </TranslationsManagerContext.Provider>
    </I18nextProvider>
  );
};

export const useTranslationsManager = () =>
  useContext(TranslationsManagerContext);

export default TranslationsProvider;
